import React from 'react';

import Button from '@atlaskit/button';
import { Checkbox } from '@atlaskit/checkbox';
import { closeDialog } from 'src/services/jira';
import { getSettings, setSettings } from 'src/services/sidebarSettings';

import ModalContainer from 'src/views/components/ModalContainer';

class ModalView extends React.Component {
  state = {
    sidebarSettings: null,
  };

  componentDidMount() {
    this.setState({ sidebarSettings: getSettings() });
  }

  onSubmit(e, settings) {
    e.preventDefault();
    e.stopPropagation();
    setSettings(settings);
    closeDialog();
  }

  render() {
    const { sidebarSettings } = this.state;
    if (!sidebarSettings) return null;

    const CheckboxField = ({ field, label }) => (
      <span style={{ width: '30vw' }}>
        <Checkbox
          isChecked={sidebarSettings[field]}
          label={label}
          onChange={e => this.setState({ sidebarSettings: { ...sidebarSettings, [field]: e.target.checked } })}
          testId={`form-field-checkbox-${field}`}
        />
      </span>
    );

    return (
      <form onSubmit={e => this.onSubmit(e, sidebarSettings)}>
        <h5>Fields visible in the sidebar:</h5>
        <div style={{ height: '60vh',
          marginTop: '1rem',
          display: 'flex',
          flexDirection: 'column', }}>
          <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
            <CheckboxField field="title" label="Title"/>
            <CheckboxField field="service" label="Service"/>
            <CheckboxField field="status" label="Status"/>
            <CheckboxField field="urgency" label="Urgency"/>
            <CheckboxField field="escalationPolicy" label="Escalation Policy"/>
            <CheckboxField field="priority" label="Priority"/>
            <CheckboxField field="assignments" label="Assignments"/>
            <CheckboxField field="incidentNumber" label="Incident Number"/>
            <CheckboxField field="pendingActions" label="Pending Actions"/>
          </div>
          <div style={{ marginTop: '1rem', display: 'flex', flexFlow: 'row wrap' }}>
            <CheckboxField field="showTimeline" label="Show Timeline"/>
            <CheckboxField field="showNotes" label="Show Notes"/>
          </div>
          <div style={{ display: 'flex', flexGrow: 1 }}>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button appearance="primary" type="submit">Save settings</Button>
          </div>
        </div>
      </form>
    );
  }
}

const ModalSidebarSettings = () => (
  <ModalContainer title={'PagerDuty Sidebar settings'}>
    <ModalView />
  </ModalContainer>
);

export default ModalSidebarSettings;
